import React from "react";

export const PackageHome: React.FC = () => <div>PackageBooking</div>;
